export default "__VITE_ASSET__CBdNUkG1__"